import { Menu, Image } from "antd";
import {
  AppstoreOutlined,
  UserOutlined,
  CustomerServiceOutlined,
  BankOutlined,
} from "@ant-design/icons";
import React from "react";
import { useNavigate } from "react-router-dom";

function CensorSideMenu() {
  const navigate = useNavigate();
  return (
    <div className="censorSideMenu">
      <Image width={150} src="/logo.png"></Image>
      <Menu
        onClick={(item) => {
          navigate(item.key);
        }}
        items={[
          {
            label: "Tổng quan",
            icon: <AppstoreOutlined />,
            key: "/censor/overview",
          },
          {
            label: "Quản lý báo cáo",
            icon: <CustomerServiceOutlined />,
            key: "/censor/moderations_log",
          },
        ]}
        selectedKeys={[window.location.pathname]}
      ></Menu>
    </div>
  );
}

export default CensorSideMenu;
